import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { SEO } from '../../seo/SEO';
import { AdminBottomNav } from '../admin/AdminBottomNav';

/**
 * Guards admin-only routes.
 * - While AuthContext is hydrating the token → /auth/me, render a spinner
 *   (prevents redirect flash on hard reload / direct URL navigation).
 * - If the resolved user is not an admin, redirect to /admin/login.
 * - Otherwise render the protected page + a shared bottom nav for
 *   phone / handheld POS form factors.
 */
export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-background flex items-center justify-center"
        data-testid="admin-route-loading"
      >
        <SEO title="Admin" noIndex includeRestaurantSchema={false} />
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user || !user.is_admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEO title="Admin" noIndex includeRestaurantSchema={false} />
      {/* Reserve room for the bottom nav on phone / POS so the page's last
          row never gets hidden under it. */}
      <div className="pb-[5.5rem] lg:pb-0">
        {children}
      </div>
      <AdminBottomNav />
    </>
  );
};

export default AdminRoute;
